import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const navLinks = [
  { label: 'HOME',     path: '/' },
  { label: 'PROJECTS', path: '/projects' },
  { label: 'SERVICES', path: '/services' },
  { label: 'LOCATION', path: '/location' },
  { label: 'CONTACT',  path: '/contact' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="nav-container">

        {/* ── LOGO ── */}
        <Link to="/" className="nav-logo-link" onClick={() => setMenuOpen(false)}>
          <img src="/image/logo.png" alt="BricksNHome" className="nav-logo-img" />
        </Link>

        {/* ── CENTER NAV LINKS ── */}
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {navLinks.map(link => (
            <li key={link.label}>
              <Link
                to={link.path}
                className={location.pathname === link.path ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* ── RIGHT CTAs ── */}
        <div className="nav-actions">
          <a
            href="https://wa.me/917477471006?text=Hi%2C%20I%20want%20to%20book%20a%20site%20visit"
            target="_blank" rel="noreferrer"
            className="nav-btn-quote"
          >
            GET QUOTE
          </a>
          <a href="tel:+917477471006" className="nav-btn-call">
            <i className="fa fa-phone" /> Call Now
          </a>
        </div>

        {/* ── HAMBURGER ── */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`fa ${menuOpen ? 'fa-times' : 'fa-bars'}`} />
        </button>

      </div>
    </nav>
  );
}
